<template>
  <div class="placeholder">
    <div class="placeholder__wrapp">
      <div class="placeholder__bg" />
    </div>
  </div>
</template>

<script lang="ts">
  export default defineNuxtComponent({
    name: 'LazyloadPlaceholder',
  });
</script>

<style lang="scss" scoped>
  @keyframes background-anim {
    0% {
      transform: translateX(-200%);
    }
    100% {
      transform: translateX(200%);
    }
  }
  .placeholder {
    width: 100%;
    height: 100%;
    overflow: hidden;

    &__wrapp {
      position: relative;
      width: 100%;
      height: 100%;
      background-color: #d8e9ff;
      overflow: hidden;
    }

    &__bg {
      position: absolute;
      width: 100%;
      height: 100%;

      background: linear-gradient(90deg, #d8e9ff00 -2.48%, #f5f9ff 49.77%, #d8e9ff 100.94%);
      animation: background-anim 2s linear infinite;
    }
  }
</style>
